const Excel = require("exceljs");

export const CreateExcelFilePayrollPNL = (data: any) => {
  const workbook = new Excel.Workbook();
  const ReporteDispersion= workbook.addWorksheet("Reporte Dispersion");

  const width = 40;

  const header = {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "002060" },
  };
  const headerFont = {
    name: "Arial",
    color: { argb: "FFFFFF" },
    family: 2,
    size: 11,
    bold: true,
  };

  ReporteDispersion.columns = [
    { header: "NOMBRE", key: "name", width },
    { header: "RFC", key: "rfc", width },
    { header: "CUENTA", key: "cuenta", width },
    { header: "CLABE", key: "clabe", width },
    { header: "BANCO", key: "banco", width },
    { header: "MONTO DISPERSAR", key: "MontoDispersar", width },
  ];

  let letter = 65;
  ReporteDispersion.columns.forEach(() => {
    ReporteDispersion.getCell(`${String.fromCharCode(letter)}1`).fill = header;
    ReporteDispersion.getCell(`${String.fromCharCode(letter)}1`).font = headerFont;
    ReporteDispersion.getCell(`${String.fromCharCode(letter)}1`).alignment = {
      horizontal: "center",
    };
    letter++;
  });

  data.forEach((item: any) => {
    // let name = item?.Colaborador.toUpperCase() || "";

    ReporteDispersion.addRow({
      name: item.Nombre,
      rfc: item.RFC,
      cuenta: item.Cuenta,
      clabe: item.Clabe,
      banco: item.Banco,
      MontoDispersar: item.MontoDispersar
      
    });
  });

  workbook.xlsx.writeBuffer().then(function (data: Blob) {
    const blob = new Blob([data],
      { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const url = window.URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = 'ReporteDispersionLayout.xlsx';
    anchor.click();
    window.URL.revokeObjectURL(url);
  });
};